export default {
    getFilter,
    fromHNode,
    pageResetRequired: true
};

function fromHNode() {
    return getFilter();
}

function getFilter() {
    return {};
}
